import { computed, type Ref } from 'vue';
import { CODE_TO_NAME_MAP } from '@/shared/lib';
import { isDirectoryContainerCode } from './mapVisibleTreeToNavigation';

export function useFilteredListHeading(itemName: Ref<string>, customFolderTitle: Ref<string>) {
  const hasRouteParams = computed(() => itemName.value.length > 0);

  const pageTitle = computed(() => {
    if (!hasRouteParams.value) return '';
    if (isDirectoryContainerCode(itemName.value)) return customFolderTitle.value;

    const segments = itemName.value.split('-');
    const firstSegment = segments[0];
    const lastSegment = segments[segments.length - 1];

    return CODE_TO_NAME_MAP[firstSegment] || CODE_TO_NAME_MAP[lastSegment] || lastSegment;
  });

  return {
    hasRouteParams,
    pageTitle,
  };
}
